/*@ngInject*/
const UISnippetsIndicatorDirective = function ($document, $timeout, submissionConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        let currentFieldName = $attr.uiSnippetsIndicatorName,
            indicator,
            parentFormStructure = $scope.$ctrl.fieldStructure.parentFormStructure || {},
            isAcordUpload = parentFormStructure.isAcordUpload;

        let createIndicator = function (fieldName) {
            let containerElement;
            indicator = $('<span class="glyphicon glyphicon-scissors"></span>').appendTo($elm);

            if ($attr.uiSnippetsIndicatorContainer === 'self') {
                containerElement = $elm;
            } else {
                containerElement = $elm.find('.' + currentFieldName);
            }

            indicator.css('left', containerElement.outerWidth());
        };

        if (isAcordUpload) {
            $scope.$on(submissionConstant.event.SET_CURRENT_SNIPPET_FIELD, function (e, fieldName, hasSnippet, isViewerOpen) {
                $elm.removeClass('currentSnippetField hasSnippet isViewerOpen');

                if (fieldName === currentFieldName) {
                    let classList = [];
                    if (!indicator) {
                        createIndicator();
                    }
                    classList.push('currentSnippetField');
                    if (hasSnippet) {
                        classList.push('hasSnippet');
                    }
                    if (isViewerOpen) {
                        classList.push('isViewerOpen');
                    }
                    $elm.addClass(classList.join(' '));
                }

                if (_.isNil(fieldName)) {
                    $('.currentSnippetField').removeClass('currentSnippetField'); // for out of viewport element
                }
            });
        }
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiSnippetsIndicator', UISnippetsIndicatorDirective);
